// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_widget_login_submit = /** @type {(inputs: {}) => string} */ () => {
	return `Enter`
};

const de_widget_login_submit = /** @type {(inputs: {}) => string} */ () => {
	return `Eingeben`
};

const es_widget_login_submit = /** @type {(inputs: {}) => string} */ () => {
	return `Participar`
};

const fr_widget_login_submit = /** @type {(inputs: {}) => string} */ () => {
	return `Entrer`
};

const fi_widget_login_submit = /** @type {(inputs: {}) => string} */ () => {
	return `Lähetä`
};

const hi_widget_login_submit = /** @type {(inputs: {}) => string} */ () => {
	return `दर्ज करें`
};

const ja_widget_login_submit = /** @type {(inputs: {}) => string} */ () => {
	return `参加する`
};

const nl_widget_login_submit = /** @type {(inputs: {}) => string} */ () => {
	return `Deelnemen`
};

const pt_widget_login_submit = /** @type {(inputs: {}) => string} */ () => {
	return `Entrar`
};

const ro_widget_login_submit = /** @type {(inputs: {}) => string} */ () => {
	return `Intră`
};

const th_widget_login_submit = /** @type {(inputs: {}) => string} */ () => {
	return `เข้าร่วม`
};

const ur_widget_login_submit = /** @type {(inputs: {}) => string} */ () => {
	return `داخل کریں`
};

const zh_hant1_widget_login_submit = /** @type {(inputs: {}) => string} */ () => {
	return `參加`
};

const da_widget_login_submit = /** @type {(inputs: {}) => string} */ () => {
	return `Deltag`
};

const it_widget_login_submit = /** @type {(inputs: {}) => string} */ () => {
	return `Partecipa`
};

const vn_widget_login_submit = /** @type {(inputs: {}) => string} */ () => {
	return `Tham gia`
};

const ko_widget_login_submit = /** @type {(inputs: {}) => string} */ () => {
	return `참여하기`
};

const tr_widget_login_submit = /** @type {(inputs: {}) => string} */ () => {
	return `Katıl`
};

const lv_widget_login_submit = /** @type {(inputs: {}) => string} */ () => {
	return `Ievadīt`
};

const ar_widget_login_submit = /** @type {(inputs: {}) => string} */ () => {
	return `دخول`
};

const bs_widget_login_submit = /** @type {(inputs: {}) => string} */ () => {
	return `Uđi`
};

const sl_widget_login_submit = /** @type {(inputs: {}) => string} */ () => {
	return `Vstopi`
};

const id_widget_login_submit = /** @type {(inputs: {}) => string} */ () => {
	return `Masuk`
};

const sv_widget_login_submit = /** @type {(inputs: {}) => string} */ () => {
	return `Delta`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "fi" | "hi" | "ja" | "nl" | "pt" | "ro" | "th" | "ur" | "zh-Hant" | "da" | "it" | "vn" | "ko" | "tr" | "lv" | "ar" | "bs" | "sl" | "id" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const widget_login_submit = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.widget_login_submit(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("widget_login_submit", locale)
	if (locale === "en") return en_widget_login_submit(inputs)
	if (locale === "de") return de_widget_login_submit(inputs)
	if (locale === "es") return es_widget_login_submit(inputs)
	if (locale === "fr") return fr_widget_login_submit(inputs)
	if (locale === "fi") return fi_widget_login_submit(inputs)
	if (locale === "hi") return hi_widget_login_submit(inputs)
	if (locale === "ja") return ja_widget_login_submit(inputs)
	if (locale === "nl") return nl_widget_login_submit(inputs)
	if (locale === "pt") return pt_widget_login_submit(inputs)
	if (locale === "ro") return ro_widget_login_submit(inputs)
	if (locale === "th") return th_widget_login_submit(inputs)
	if (locale === "ur") return ur_widget_login_submit(inputs)
	if (locale === "zh-Hant") return zh_hant1_widget_login_submit(inputs)
	if (locale === "da") return da_widget_login_submit(inputs)
	if (locale === "it") return it_widget_login_submit(inputs)
	if (locale === "vn") return vn_widget_login_submit(inputs)
	if (locale === "ko") return ko_widget_login_submit(inputs)
	if (locale === "tr") return tr_widget_login_submit(inputs)
	if (locale === "lv") return lv_widget_login_submit(inputs)
	if (locale === "ar") return ar_widget_login_submit(inputs)
	if (locale === "bs") return bs_widget_login_submit(inputs)
	if (locale === "sl") return sl_widget_login_submit(inputs)
	if (locale === "id") return id_widget_login_submit(inputs)
	if (locale === "sv") return sv_widget_login_submit(inputs)
	return "widget_login_submit"
};